t = require('views/internal/teacup-with-helpers')('header_user_anonymous')

module.exports = t.renderable ({ escapedReturnUrl }) ->
  t.a '.header-btn.header-signup', { href: '/signup' + if escapedReturnUrl then '?returnUrl=' + escapedReturnUrl else '' }, ->
    t.format 'sign-up'
  t.a '.header-btn.header-login.no-right-margin', { href: '/login' + if escapedReturnUrl then '?returnUrl=' + escapedReturnUrl else '' }, ->
    t.format 'log-in'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_user_anonymous.coffee